module.exports = __webpack_public_path__ + "static/media/foilGlitterySilver.2d10ee00.svg";